import React from 'react';
import {ItemPresenter} from "../ItemPresenter";

function AnimalRooster() {
  return (
    <ItemPresenter imagePath={"/images/animals/rooster.png"} bottomLabel={"Galo"}
      customImageWidth={" "}
      />
  );
}

export default AnimalRooster;